import Macy from 'macy'
import InfiniteScroll from 'infinite-scroll'
import { find, findFirst } from 'helpers/vanilla'

//const $ = window.jQuery

const Masonry = () => {

  const name = 'masonry'
  let $blog_masonry

  const loadCondition = () => {
    $blog_masonry = findFirst('.latest-articles')
    return $blog_masonry
  }

  const init = () => {

    var macy = Macy({
        container: '.latest-articles',
        trueOrder: false,
        waitForImages: true,
        margin: 40,
        columns: 2,
        breakAt: {
            //520: 2,
            1024: 1
        }
    });

    macy.runOnImageLoad(function () {
      macy.recalculate(true);
    }, true);


    if ($('.button-bw').length) {

      var elem = document.querySelector('.latest-articles');
      var infScroll = new InfiniteScroll( elem, {
        path: '.button-bw',
        checkLastPage: true,
        append: '.article',
        history: false,
        hideNav: '.nav-news',
        //debug: true
      });

      infScroll.on( 'append', function( response, path, items ) {
        macy.runOnImageLoad(function () {
          macy.recalculate(true);
        }, true);
      });

    }

  }

  //init()
  return { loadCondition, name, init }
}

export default Masonry



// WEBPACK FOOTER //
// public/content/themes/farrach/src/js/components/masonry.js